import { FC } from 'react';
import { LoaderSpinner } from "./LoaderAnimation";

export const LoadingModal: FC<{}> = (props) => {
    return <LoaderSpinner {...props}></LoaderSpinner>
}import { FC } from 'react';
import { LoaderSpinner } from "./LoaderAnimation";

export const LoadingModal: FC<{}> = (props) => {
    return <LoaderSpinner {...props}></LoaderSpinner>
}